<template>
    <div class="content-wrapper">
        <!-- Page Loader -->
        <div class="vld-parent">
            <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        </div>

        <breadcrumb :page="$t('form.employee.staffList')"></breadcrumb>

        <div class="content">
            <div class="container-fluid">

                <b-alert v-model="alert" :variant="alertClass" dismissible fade>{{alertMessage}}</b-alert>

                <!-- Filters -->
                <div class="card">
                    <div class="card-header bg-light">
                        <div class="card-title">{{$t('filters')}}</div>
                        <div class="text-right">
                            <b-button variant="primary" size="sm" @click="detailedSearch = !detailedSearch">
                                {{$t('button.detailedSearch')}}</b-button>
                            <b-button variant="default" size="sm" @click="clearSearch()">{{$t('button.resetFilter')}}
                            </b-button>
                        </div>
                    </div>

                    <div class="card-body">
                        <form role="form">

                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>{{$t('form.employee.searchCriteria')}}</label>
                                        <v-select @input="loadPreset" label="name" :options="presetList"
                                            v-model="preset">
                                        </v-select>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <label>{{$t('form.employee.name')}}</label>
                                        <input type="text" class="form-control" v-model="search.name"
                                            @keyup="searchStaff">
                                    </div>
                                </div>

                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <label>{{$t('form.employee.department')}}</label>
                                        <v-select @input="searchStaff" :options="departments"
                                            v-model="search.Department"
                                            :reduce="departments => departments">
                                        </v-select>
                                    </div>
                                </div>

                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <label>{{$t('form.employee.position')}}</label>
                                        <v-select @input="searchStaff" :options="positions"
                                            v-model="search.Position" :reduce="positions => positions">
                                        </v-select>
                                    </div>
                                </div>

                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <label>{{$t('form.employee.status')}}</label>
                                        <v-select
                                        @input="searchStaff"
                                        label="Name"
                                        :options="status"
                                        v-model="search.Status"
                                        :reduce="(status) => status.id"
                                        >
                                        </v-select>
                                    </div>
                                </div>
                            </div>

                            <div class="row" v-if="detailedSearch">
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <label>{{$t('form.employee.firstName')}}</label>
                                        <input type="text" v-model="search.firstName" @keyup="searchStaff"
                                            class="form-control">
                                    </div>
                                </div>

                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <label>{{$t('form.employee.lastName')}}</label>
                                        <input type="text" v-model="search.lastName" @keyup="searchStaff"
                                            class="form-control">
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <label>{{$t('form.employee.birthDate')}}</label>
                                        <input type="date" v-model="search.birthDate" @change="searchStaff"
                                            class="form-control">
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <label>{{$t('form.employee.birthPlace')}}</label>
                                        <input type="text" v-model="search.birthPlace" @keyup="searchStaff"
                                            class="form-control">
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <label>{{$t('form.employee.birthCountry')}}</label>
                                        <v-select @input="searchStaff" label="printable_name" :options="countries"
                                            v-model="search.birthCountry"
                                            :reduce="countries => countries.printable_name">
                                        </v-select>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <label>{{$t('form.employee.streetAddress')}}</label>
                                        <input type="text" v-model="search.streetAddress" @keyup="searchStaff"
                                            class="form-control">
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <label>{{$t('form.employee.city')}}</label>
                                        <input type="text" v-model="search.city" @keyup="searchStaff"
                                            class="form-control">
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <label>{{$t('form.employee.postalCode')}}</label>
                                        <input type="text" v-model="search.zip" @keyup="searchStaff"
                                            class="form-control">
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <label>{{$t('form.employee.country')}}</label>
                                        <v-select @input="searchStaff" label="printable_name" :options="countries"
                                            v-model="search.country"
                                            :reduce="countries => countries.printable_name">
                                        </v-select>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <label>{{$t('form.employee.phone')}}</label>
                                        <input type="text" v-model="search.phone" @keyup="searchStaff"
                                            class="form-control">
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <label>{{$t('form.employee.mobile')}}</label>
                                        <input type="text" v-model="search.mobile" @keyup="searchStaff"
                                            class="form-control">
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <label>{{$t('form.employee.email')}}</label>
                                        <input type="text" v-model="search.email" @keyup="searchStaff"
                                            class="form-control">
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <label>{{$t('form.employee.webAddress')}}</label>
                                        <input type="text" v-model="search.webAddress" @keyup="searchStaff"
                                            class="form-control">
                                    </div>
                                </div>
                                <div class="col-12">
                                    <hr>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <input type="text" v-model="preset.name" class="form-control"
                                            :placeholder="$t('form.employee.presetName')">
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <button type="button" class="btn btn-primary"
                                        @click="savePreset">{{$t('button.save')}}</button>
                                    <button type="button" class="btn btn-danger" v-show="presetSelected"
                                        @click="deletePreset">{{$t('button.delete')}}</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>

                <div class="card">
                    <div class="card-header bg-light">
                        <div class="card-title">{{$t('form.employee.staffList')}}</div>
                    </div>
                    <div class="card-body table-responsive p-0">
                        <table class="table table-hover" v-if="staff.length">
                            <thead>
                                <tr class="header">
                                    <th>{{$t('form.employee.name')}}</th>
                                    <th>{{$t('form.employee.position')}}</th>
                                    <th>{{$t('form.employee.status')}}</th>
                                    <th class="text-right">{{$t('form.employee.action')}}</th>
                                </tr>
                            </thead>

                            <tbody v-for="(staff, index) in staff" v-bind:key="index">
                                <tr @dblclick="goToEdit(staff.ID)">
                                    <td>{{staff.FirstName }} {{staff.LastName}}</td>
                                    <td>{{staff.Position}}</td>
                                    <td>{{staff.Status}}</td>
                                    <td class="text-right">
                                        <button v-if="permissions.viewEmployeeStaff" class="btn btn-info btn-sm"
                                            @click="goToEdit(staff.ID)">
                                            <span class="fa fa-edit"></span>
                                        </button>
                                        <button v-if="permissions.deleteEmployeeStaff" class="btn btn-danger btn-sm"
                                            @click="deleteStaff(staff.ID, index)">
                                            <span class="fa fa-trash"></span>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <p class="p-3 m-0" v-else>{{$t('noRecord')}}</p>
                    </div>

                    <pagination v-if="pagination.last_page > 1" :pagination="pagination" :offset="5"
                        @paginate="paginate()">
                    </pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['permissions'],

        data() {
            return {
                alert: false,
                alertClass: '',
                alertMessage: '',

                isLoading: false,
                fullPage: true,

                detailedSearch: false,
                presetSelected: false,
                request_source: '',
                activeStatusId: null,

                pagination: {
                    current_page: 1
                },

                search: {
                    Status: { id: null }
                },

                preset: {
                    name: '',
                    entity: 'staff',
                    value: {}
                },

                titles: [],
                positions: [],
                status: [],
                departments: [],
                countries: [],
                presetList: [],
                staff: []
            }
        },

        async mounted() {
            this.isLoading = true;

            if (!this.permissions.viewEmployeeStaff) {
                this.$router.push('/');
                return;
            }

            await this.getInitialData();

            if (localStorage.getItem('filter-staff')) {
                this.search = JSON.parse(localStorage.getItem('filter-staff'));
            }

            this.getStaff();
            this.getPresets();

            this.setDefaultStatusId();
        },

        watch: {
            search: {
                handler() {
                    localStorage.setItem('filter-staff', JSON.stringify(this.search));
                },
                deep: true
            }
        },

        methods: {

            async getInitialData() {
                let response = await axios.get("/api/staff/initial-data");

                if (response.data) {
                    let data = response.data;
                    
                    this.departments = data.departments;
                    this.positions = data.positions;
                    this.countries = data.countries;
                    this.titles = data.titles;
                    this.status = data.status;

                    const activeStatus = this.status.find(status => status.Name === "Active");
                    if (activeStatus) {
                        this.activeStatusId = activeStatus.id;
                    }
                }
            },

            setDefaultStatusId() {
                // Set the default status ID to the ID of the "Active" status
                this.search.Status = this.activeStatusId;
            },

            // Clear search input fields
            clearSearch() {
                this.search = {};
                this.searchStaff();
            },

            goToEdit(id) {
                if (!this.permissions.viewEmployeeStaff) return;

                this.$router.push({
                    name: 'StaffEdit',
                    params: {
                        id: id
                    }
                });
            },

            deleteStaff(id, index) {
                if (!this.permissions.deleteEmployeeStaff) return;

                let conf = confirm(this.$t('form.validation.delete'));

                if (conf === true) {

                    axios
                        .delete('/api/staff/' + id)
                        .then(response => {
                            this.loading = false;
                            this.staff.splice(index, 1);
                            if (this.staff.length < 5) this.getStaff();
                            this.showAlert(response.data.message);
                        })
                        .catch(error => {
                            this.loading = false;
                            console.log('Error occured while deleting');
                        });
                }
            },

            getStatusName(statusId) {
                const status = this.status.find(s => s.id === statusId);
                if (status) {
                    return status.Name;
                }
            },

            getStaff() {
                let source = axios.CancelToken.source();

                if (this.request_source != '')
                    this.request_source.cancel('Operation canceled by the user.');

                this.request_source = source;

                this.isLoading = true;

                axios
                    .get('/api/staff?page=' + this.pagination.current_page, {
                        params: this.search,
                        cancelToken: this.request_source.token
                    })
                    .then(response => {
                        this.staff = response.data.data.data.map(staffMember => {
                            const statusId = staffMember.Status;
                            return {
                                ...staffMember,
                                Status: this.getStatusName(statusId)
                            };
                        });
                        this.pagination = response.data.pagination;
                        this.isLoading = false;
                    })
                    .catch(error => {
                        this.isLoading = false;
                        console.log('error');
                    });
            },

            paginate() {
                this.getStaff();
            },

            searchStaff() {
                this.pagination.current_page = 1;
                this.getStaff();
            },

            // Save a Preset with Unique Name
            savePreset() {
                this.isLoading = true;
                this.alert = false;

                this.preset.value = JSON.stringify(this.search);

                axios
                    .post('/api/presets', this.preset)
                    .then(response => {
                        this.isLoading = false;
                        this.showAlert(response.data.message);
                        this.getPresets();
                    }, error => {
                        this.isLoading = false;

                        if (error.response.status == 422) {
                            this.showAlert(error.response.data.errors.name[0], 'danger');
                        }
                    });
            },

            // Get Presets in Search Criteria 
            getPresets() {
                axios
                    .get('/api/presets/?entity=' + this.preset.entity)
                    .then(response => {
                        this.presetList = response.data;
                    }, error => {
                        console.log(error.response);
                    });
            },

            // Get Search results according to selected Preset Name
            loadPreset() {
                if (!this.preset) {
                    this.preset = {
                        entity: 'staff'
                    };
                    this.clearSearch();
                    this.alert = false;
                    this.presetSelected = false;
                    return;
                }
                this.alert = false;
                this.presetSelected = true;
                this.search = JSON.parse(this.preset.value);
                this.searchStaff();
            },

            // Delete a selected Preset
            deletePreset() {
                let conf = confirm(this.$t('form.validation.delete'));

                if (conf === true) {
                    axios
                        .delete("/api/presets/" + this.preset.id)
                        .then(response => {
                            if (response.data.status == 'success') {
                                this.showAlert(response.data.message);
                                this.getPresets();
                                this.clearSearch();
                                this.preset.name = '';
                                this.preset.value = {};
                                this.presetSelected = false;
                            }
                        })
                        .catch(error => {
                            this.isLoading = false;
                        });
                }
            },

            showAlert(msg, cls = 'success') {
                this.alertMessage = msg;
                this.alertClass = cls;
                this.alert = true;
            }
        }
    }

</script>
